import { h, Component } from 'preact'

class Iframe extends Component {
  shouldComponentUpdate () {
    return false
  }

  render ({ src }) {
    return h('iframe', {
      className: 'iframe',
      key: src,
      src
    })
  }
}

export default Iframe
